export default {
  roleAdmin: 'role managerment',
  roleList: 'role list',
  roleCoding: 'role code',
  roleName: 'role name',
  roleId: 'role ID',
  selectroleId: 'Select role ID',
  creator: 'creator',
  Remarks: ' Remarks',
  modiFicaTion: 'edit',
  View: 'View',
  compileRole: 'Edit role',
  inputNull: 'Search cannot be empty',
  addRole: 'add role',
  checkRole: 'view role',
  deviceInfo: 'deviceInfo',

  data: {
    roleCode: 'please enter role code',
    roleName: 'please enter role name',

    distributedId: 'Please select distributed ID first',
    addRoleError: 'add role failed',
    changRoleError: 'modify role failed'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/rolemanager.js